import type { TConversionPair } from '../../store/types';

export const getConversionPairTitle = (pair: TConversionPair) => `${pair.baseCurrency}/${pair.quoteCurrency}`;
